import React, { useMemo } from 'react';
import {
  Datagrid,
  TextField,
  ReferenceField,
  FunctionField,
  linkToRecord,
  SelectField
} from 'react-admin';
import CircularProgress from '@material-ui/core/CircularProgress';
import { withStyles } from '@material-ui/core/styles';
import Empty from '../../core/components/list/Empty';
import { userStatus, userTypeSA } from '../users/UserLookups';
import StatusSelectField from '../../core/components/StatusSelectField';

const styles = () => ({
  progress: {
    display: 'flex',
    justifyContent: 'center'
  },
  paddingCheckbox: {
    display: 'none'
  },
  headerCell: {
    '& tr': {
      '& th:nth-of-type(1)': {
        display: 'none'
      }
    }
  },
  tbody: {
    '& td:nth-of-type(1)': {
      display: 'none'
    }
  }
});

const RelatedContactsDatagrid = props => {
  const { classes, permissions, ...dataGridProps } = props;

  const hasReadUserPermission = useMemo(() => {
    return permissions.includes('AUTH_READ_USER_NA');
  }, [permissions]);

  if (props.total > 0) {
    return (
      <Datagrid
        {...dataGridProps}
        classes={{ thead: classes.headerCell, tbody: classes.tbody }}
      >
        <ReferenceField
          label="Contact Name"
          source="userId"
          reference="usersOrphanVisibilityOn"
          sortBy="user.nickName"
          sortable={false}
          link={record =>
            hasReadUserPermission
              ? `${linkToRecord(`/users`, record.userId)}`
              : false
          }
        >
          <FunctionField
            label="Name"
            render={record => `${record.firstName} ${record.lastName}`}
          />
        </ReferenceField>
        <TextField label="User ID" sortable={false} source="userId" />
        <ReferenceField
          label="User Type"
          source="userId"
          reference="usersOrphanVisibilityOn"
          sortable={false}
          link={false}
        >
          <SelectField
            label="User Type"
            source="userType"
            choices={userTypeSA}
          />
        </ReferenceField>
        <ReferenceField
          label="Email Address"
          source="userId"
          reference="usersOrphanVisibilityOn"
          sortable={false}
          link={false}
        >
          <TextField source="email" />
        </ReferenceField>
        <ReferenceField
          label="Status"
          source="userId"
          reference="usersOrphanVisibilityOn"
          sortable={false}
          link={false}
        >
          <StatusSelectField
            label="Status"
            source="status"
            choices={userStatus}
          />
        </ReferenceField>
      </Datagrid>
    );
  } else if (props.loading) {
    return (
      <div className={classes.progress}>
        <CircularProgress />
      </div>
    );
  } else {
    return (
      <Empty
        emptyText="There are no users related to this role"
        title="Related Contacts"
      />
    );
  }
};

export default withStyles(styles)(RelatedContactsDatagrid);
